/**
 * SoleadLab 2.0 - Photo Viewer Modal
 *
 * Shows full-size preview of a Photo-type indication image
 * with GPS metadata. Opened when clicking a Photo indication on the map.
 */

import { useUIStore } from '../../stores';
import './PhotoViewerModal.css';

export default function PhotoViewerModal() {
  const { modalData, closeModal } = useUIStore();
  const imageSrc = (modalData?.imageSrc as string) || '';
  const notes = (modalData?.notes as string) || '';

  return (
    <div className="photo-viewer-backdrop" onClick={closeModal}>
      <div className="photo-viewer-modal" onClick={(e) => e.stopPropagation()}>
        <button className="photo-viewer-close" onClick={closeModal}>
          &times;
        </button>
        {imageSrc && (
          <img
            src={imageSrc}
            alt="Geo photo"
            className="photo-viewer-image"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        )}
        {notes && <pre className="photo-viewer-notes">{notes}</pre>}
      </div>
    </div>
  );
}
